export default "__VITE_ASSET__690f7c65__"